import { render, staticRenderFns } from "./parent_register.vue?vue&type=template&id=f7f7bf72"
import script from "./parent_register.vue?vue&type=script&lang=js"
export * from "./parent_register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports